import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { CategoryMenuBar } from '@hz-design-system/web-ui';

type TCategoryMenuBarAppProps = { appState: any };

const CategoryMenuBarApp = ({ appState: { categoryLinks, topCategories } }: TCategoryMenuBarAppProps) => {
  const { t } = useI18nContext();

  if (!topCategories.length) {
    return null;
  }

  return (
    <CategoryMenuBar
      l1Categories={categoryLinks}
      topCategories={topCategories}
      toggleLabel={t('l1.navigation.categories.all_categories')}
    />
  );
};

export default CategoryMenuBarApp;
